import { render, staticRenderFns } from "./per.vue?vue&type=template&id=b9a52576&scoped=true&"
import script from "./per.vue?vue&type=script&lang=js&"
export * from "./per.vue?vue&type=script&lang=js&"
import style0 from "./per.vue?vue&type=style&index=0&id=b9a52576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a52576",
  null
  
)

export default component.exports